// Must match `AI_UNAVAILABLE_DETAILS` in functions/constants/ai.js; the test checks it.
export const AI_UNAVAILABLE_ERROR_CODE = 'ai-unavailable';

/**
 * @param {Error & {details?: {code?: string}}} err A rejected callable
 * @returns {boolean}
 */
export function isAIUnavailableError(err) {
  return err?.details?.code === AI_UNAVAILABLE_ERROR_CODE;
}

/**
 * @param {Error} err A rejected callable
 * @param {string} fallbackKey The dictionary key for any failure other than an AI outage
 * @returns {string} The dictionary key to show
 */
export function aiErrorMessageKey(err, fallbackKey) {
  return isAIUnavailableError(err) ? 'common.errors.aiUnavailable' : fallbackKey;
}
